/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.admin.disableAccountInvites'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  account: /*#__PURE__*/ l.string({ format: 'did' }),
  note: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload()

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Disable an account from receiving new invite codes, but does not invalidate existing codes. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

export const $lxm = $nsid
